import { environment } from './environments/environment';

/** Carrega o script oficial da API JavaScript do Maps (evita chave em index.html / scan do Netlify). */
export function loadGoogleMapsScript(): Promise<void> {
  const key = environment.googleMapsApiKey?.trim() ?? '';
  if (!key) {
    return Promise.resolve();
  }
  if (typeof document === 'undefined' || typeof window === 'undefined') {
    return Promise.resolve();
  }
  const w = window as unknown as { google?: { maps?: unknown } };
  if (w.google?.maps) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const sel = 'script[data-velz-google-maps]';
    const existing = document.querySelector<HTMLScriptElement>(sel);
    if (existing) {
      if (w.google?.maps) {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error('Google Maps')), { once: true });
      return;
    }

    const s = document.createElement('script');
    s.dataset['velzGoogleMaps'] = '1';
    s.async = true;
    s.defer = true;
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}`;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Falha ao carregar Google Maps'));
    document.head.appendChild(s);
  });
}
